import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromRoot from '../../reducers/index';
import * as fromUploader from './store/reducers';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent implements OnInit, OnDestroy {

  step$: Observable<string>;
  subscriptions: Subscription[] = [];

  constructor(
    private readonly store$: Store<fromRoot.State & fromUploader.State>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.step$ = this.store$.pipe(select(fromUploader.getStep));
  }

  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      this.renderer.addClass(this.document.body, 'prepare');
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(this.document.body, 'prepare');
    }
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
